module.exports = __webpack_public_path__ + "img/tiktok.36c0d828.svg";